export default __webpack_public_path__ + "static/media/ic_goal.122d5faa.svg";